import React, { useEffect } from 'react';

import Layout from '../../containers/Layout';
import Title from '../../components/Title';
import OrderDetails from '../../components/OrderDetails';
import AddressDelivery from '../../components/AddressDelivery';
import PaymentCard from '../../components/PaymentCard';
import OrderTotal from '../../components/OrderTotal';
import { Order } from '../../requests/caipirinha-api/interfaces/order.interface';
import withDocument from '../../hocs/withDocument';
import CardBox from '../../components/CardBox';
import { useCheckoutGtm } from '../../hooks/gtm/checkout/useCheckoutGtm';
import { LGPDInvite } from '../../requests/interfaces/commons.interface';
import LgpdCard from '../../components/LgpdCard';
import IcOrder from '../../assets/icons/ic_order.svg';
import IcCard from '../../assets/icons/ic_card.svg';
import { PaymentMethodType } from '../../constants/paymentMethodType.enum';
import CreditCardPCJ from '../../components/CreditCardPCJ';

interface Props {
  order: Order;
  lgpd?: LGPDInvite;
}

export const Receipt: React.FC<Props> = ({ order, lgpd }) => {
  const { sendDataToGtm } = useCheckoutGtm();
  const { details: { payments, amount } } = order;

  const simulatedPayment = payments[0].type === PaymentMethodType.CARD &&
    payments[0].simulated
    ? payments[0] : null;

  useEffect(() => {
    if (order)
      sendDataToGtm(order, {
        type: 'checkout',
        name: '/pagamento/confirmacao-transacao',
      });
    // eslint-disable-next-line
  }, [order]);

  return (
    <Layout title="Comprovante de compra" dark>
      <Title icon={IcOrder} small>
        Pedido
      </Title>
      {order?.details && (
        <>
          <OrderDetails
            order={order}
            products={order.details.products}
            services={order.details.services}
            shipping={order.details.shipping}
          />

          <Title icon={IcCard} small>
            Resumo do Pagamento
          </Title>

          {payments && !simulatedPayment && (
            <CardBox>
              <OrderTotal payments={order.details.payments} />
            </CardBox>
          )}

          { simulatedPayment && (
            <CreditCardPCJ paymentCard={simulatedPayment} totalOrder={amount}/>
          )}

          {order.details.card && <PaymentCard card={order.details.card} />}

          {order?.details?.delivery?.address && (
            <AddressDelivery address={order.details.delivery.address} />
          )}
        </>
      )}
      {lgpd?.self && <LgpdCard url={lgpd.self.offerPolicy} />}
    </Layout>
  );
};

export default withDocument(
  Receipt,
  'Para sua segurança, informe o seu {documentName} para visualizar o seu comprovante!',
  true,
);
